export const MOVIE_LIST_REQUEST = "MOVIE_LIST_REQUEST";
export const GET_MOVIE_LIST_SUCCESS = "GET_MOVIE_LIST_SUCCESS";
export const GET_MOVIE_LIST_FAILED = "GET_MOVIE_LIST_FAILED";

export const GET_MOVIE_DETAIL_SUCCESS = "GET_MOVIE_DETAIL_SUCCESS";
export const GET_MOVIE_DETAIL_FAILED = "GET_MOVIE_DETAIL_FAILED";
